import React from 'react';

import Table from '../../../../../../components/table/Table';
import { columns } from './columns';
import { UserGradeHistoryItemType } from '../types';

interface IAccountUserDetailHistoryProps {
  histories: UserGradeHistoryItemType[];
}

type HistoryTableColumnsArgs = {
  list: UserGradeHistoryItemType[];
};

const AccountUserDetailHistory = (props: IAccountUserDetailHistoryProps): JSX.Element => {
  const { histories } = props;

  return (
    <div className="account-user-detail-section">
      <div className="title">유저 등급 히스토리</div>

      <div className="account-user-detail-section-content">
        <Table
          data={histories}
          columns={(utils: HistoryTableColumnsArgs) => columns({ ...utils })}
          emptyText="등급 히스토리가 존재하지 않습니다"
        />
      </div>
    </div>
  );
};

export default AccountUserDetailHistory;
